import { InnovaAlgoTrade } from "@/client-admin/types.gen";
import { columns } from "./columns";
import { DataTable } from "./data-table";

type Props = {
  rows: InnovaAlgoTrade[];
};

export function SlicesTable({ rows }: Props) {
  return <DataTable columns={columns} data={rows} />;
}
